// extracted by mini-css-extract-plugin
export default {"productCarousel":"k0-z"};